import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import Amplify from 'aws-amplify';
import router from './router'
import store from './store'
import config from '../../config.json'


Amplify.configure({
  Auth:{
    mandatorySignId:true,
    region:config.Region,
    userPoolId:config.UserPoolId,
    userPoolWebClientId:config.UserPoolClientId,
    identityPoolId:config.IdentityPoolId
  }
})

store.commit('setEndpoint',config.ServiceEndpoint)

Vue.config.productionTip = false
Vue.use(VueCookies)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
